import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bind",
  "use": "icon-bind-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bind\"><path d=\"M853.7 170.3c-46.5-46.5-108.5-72.1-174.4-72.1h-0.1c-66 0-127.9 25.6-174.4 72.1L365.6 309.5l52.6 52.6L557.5 223c67.1-67.1 176.4-67.1 243.5 0s67.1 176.3 0 243.5L661.7 605.7l52.6 52.6 139.4-139.2c46.5-46.5 72.1-108.4 72.1-174.4s-25.6-127.9-72.1-174.4zM466.4 801c-32.4 32.5-75.7 50.5-121.7 50.5s-89.3-17.9-121.8-50.5c-32.5-32.5-50.4-75.7-50.4-121.7s17.9-89.3 50.4-121.7l139.2-139.3-52.6-52.6-139.2 139.1c-46.5 46.5-72.1 108.4-72.1 174.4s25.6 127.9 72.1 174.4c46.6 46.6 108.5 72.3 174.4 72.3s127.8-25.7 174.4-72.3l139.1-139.2-52.6-52.6L466.4 801z\" p-id=\"2065\" /><path d=\"M328.683 642.541l313.714-313.625 52.672 52.686-313.714 313.626z\" p-id=\"2066\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bind.svg
// module id = 17vA
// module chunks = 12